// extracted by mini-css-extract-plugin
export default {"page-shop":"cabinet_page-shop__4zIZ2","title":"cabinet_title__SruK6","ellipsis":"cabinet_ellipsis__oPFMn"};